module.exports = __webpack_public_path__ + "static/media/loading.1b90c507.svg";